import React from "react";
import './index.less'
import douyin from '@/assets/Social Icons.png'
import facebookIcon from '@/assets/Social Icons2.png';
// const instagramLogo = require('../../../assets/social_media/instagram.jpeg');
import instagramLogo from '@/assets/Social Icons1.png';
// import twitterLogo from '../../../assets/social_media/twitter.svg';
import douyincolor from '@/assets/Social3.png'
import inscolor from '@/assets/Social4.png'
import facecolor from '@/assets/Social5.png'
import { useHistory, Link } from "umi";
const CompanyRight = ()=>{
    return(
      <div className = 'footer_2021'>
        ©️ 2021 ModCart LLC
      </div>
    )
  }
const SocialMedia = (props:any) => {
  const {isHomepage,bottom} = props
    return (
        <div className='footer_external' style={{marginBottom:bottom?60:0}}>
                Follow ModCart on: &nbsp;
                <a href="https://www.tiktok.com/@modcart_living" target="_blank" rel="noopener noreferrer">
                    <img src={isHomepage ? douyin : douyincolor} width={40} height={40} />
                </a>
                <a href="https://www.instagram.com/modcart.atlanta/" target="_blank" rel="noopener noreferrer">
                    <img src={isHomepage ? instagramLogo : inscolor} width={40} height={40} />
                </a>
                <a 
                  href="https://www.facebook.com/ModCart.Atlanta" target="_blank" rel="noopener noreferrer">
                    <img src={isHomepage ? facebookIcon : facecolor} width={40} height={40} />
                </a>&nbsp;
                {/* <a href="https://twitter.com/modcart_atlanta" target="_blank" rel="noopener noreferrer">
                    <img src={twitterLogo} width={20} height={20} />
                </a> */}
        </div>
    )
}
const LinksOne = ()=>{
    return (
      <div className='footer_taber_one'>
        <div  style={{paddingLeft:0}}>
          {/* <a href = "https://help.modcart.com/contact-us/" target = "__bank" rel="noopener noreferrer">Contact Us</a> */}
          <a href="/contactus">Contact Us</a>
        </div>
        <div style={{border:'none',paddingRight:0}}>
          {/* <a href = "https://help.modcart.com/about" target = "__bank" rel="noopener noreferrer">About Us</a> */}
          <a href="/contactus">About Us</a>
        </div>
        <div style={{border:'none',paddingRight:0}}>
          <a href="/helpus">Help Us</a>
        </div>
      </div>
    )
}
const LinksTwo = (props:any)=>{
    return (
      <div className='footer_taber_two'>
        <div style={{paddingLeft:0}}>
          {/* <a href = "https://help.modcart.com/faqs/" target = "__bank" rel="noopener noreferrer">FAQs</a> */}
          <a href="/faq">FAQs</a>
        </div>
        <div>
          {/* <a href = "https://help.modcart.com/terms-of-use/" target = "__bank" rel="noopener noreferrer">Terms of Use</a> */}
          <a href="/policies#section6">Terms of Use</a>
        </div>
        <div style={{border:'none',paddingRight:0}}>
          {/* <a href = "https://help.modcart.com/privacy-policy-2/" target = "__bank" rel="noopener noreferrer">Privacy Policy</a> */}
          <a href="/policies#section1">Privacy Policy</a>
        </div>
      </div>
    )
  }
const PageFooter = (props:any) => {
  console.log('footer',props)
  const history = useHistory()
  const isHomepage = history.location.pathname == '/'
    return(
        <>
            <div className={isHomepage ? "categoryFooter bgpink" : 'categoryFooter'}>
                <CompanyRight/>
                <LinksOne/>
                <LinksTwo />
                <SocialMedia isHomepage={isHomepage} bottom={props.bottom}/>
                
            </div>
        </>
    )
}
export default PageFooter;